<template>

  <div>
    <!-- 面包屑导航区 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>基础信息</el-breadcrumb-item>
      <el-breadcrumb-item>部门管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card  :body-style="{ padding: '10px',paddingBottom:'40px' }" >


<!--      <div v-if="company.newCompanyStatus == 1">-->
<!--        <el-alert-->
<!--          title="薪资查询助手,新用户免费试用12个月!"-->
<!--          type="warning"-->
<!--          center-->
<!--          show-icon>-->
<!--        </el-alert>-->
<!--      </div>-->

    <el-descriptions class="margin-top"  title="企业信息" :column="3"  border>
      <template slot="extra">
        <el-button type="primary"  @click="goUpdate()" size="small">修改</el-button>
      </template>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user"></i>
          企业名称
        </template>
        {{company.companyName}}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-mobile-phone"></i>
          手机号
        </template>
       {{company.companyPhone}}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-office-building"></i>
          每月可使用人数 (加赠送10%)
        </template>
          {{company.shopNumber}}人
      </el-descriptions-item>


      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-office-building"></i>
          联系地址
        </template>
        {{company.companyAddress}}
      </el-descriptions-item>


      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-office-building"></i>
          企业编号
        </template>
        {{company.companyCode}}
      </el-descriptions-item>



    </el-descriptions>



    <el-dialog title="修改企业信息" :visible.sync="companyDialogVisible"  center width="500px"  append-to-body>
      <el-form :model="companyUpdate">
        <el-form-item label="企业名称"  style="width: 320px">
          <el-input v-model="companyUpdate.companyName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系方式"  style="width: 320px">
          <el-input v-model="companyUpdate.companyPhone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="企业地址"  style="width: 320px">
          <el-input v-model="companyUpdate.companyAddress" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="companyDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateCompany()">确 定</el-button>
      </div>
    </el-dialog>

    </el-card>
  </div>


</template>

<script>
export default {
  data () {

    return {
        company:{
          companyName:"",
          companyPhone:"",
          companyAddress:"",
          shopNumber:"",
        },

        companyUpdate:{
          companyName:"",
          companyPhone:"",
          companyAddress:""
        },

       companyDialogVisible:false,
      }
  },
  created () {
    this.getCompany();
  },
  methods: {
    async getCompany(){
      const { data: res } = await this.$http.post('company/queryCompanyData',{})   //get参数用params获得
      if(res.code !== '10000') {
        return this.$message.error(res.msg);
      }
      this.company = res.data;


      if(res.data.companyName == ""){
        this.company.companyName = "请输入企业名称"
      }

    },
    async updateCompany(){
      this.companyUpdate.companyId = this.company.companyId;
      const { data: res } = await this.$http.post('company/updateCompany',this.companyUpdate)   //get参数用params获得
      if(res.code !== '10000') {
        return this.$message.error(res.msg);
      }
      this.getCompany();
      this.companyDialogVisible = false;
    },
    async goUpdate(){
      this.companyUpdate.companyName = this.company.companyName;
      this.companyUpdate.companyPhone = this.company.companyPhone;
      this.companyUpdate.companyAddress = this.company.companyAddress;
      this.companyDialogVisible = true;
    },
  }
}

</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/company/Company.vue